import React, { FC, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { IBankAccount } from '@sparling/financial-common'
import { Modal } from '../../../../../../../components/Dashboard/Modal'
import { deleteUserBankAccountRequest } from '../../../../../../../store/actions'

export const RemoveConfirmationModal: FC<{
  account: IBankAccount
  isOpen: boolean
  onClose: () => void
}> = ({ isOpen, onClose, account }) => {
  const dispatch = useDispatch()

  const onConfirm = useCallback(() => {
    dispatch(
      deleteUserBankAccountRequest({
        id: account?.id,
      }),
    )
    onClose?.()
  }, [account?.id, dispatch, onClose])

  return (
    <Modal isOpen={isOpen} title="Remove Confirmation" modalClose={onClose} onSubmit={onConfirm} isSubmit>
      <p>Are you sure you want to remove {account?.bankName} bank account?</p>
    </Modal>
  )
}
